import {combineReducers} from 'redux';
import {FETCH_POST, _SUCCESS, _ERROR, _REQUEST} from './reducers-const';
import {Article} from './article';

function data(state = [], action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data.items;
    case `${FETCH_POST}${_ERROR}`:
    default:
      return state;
  }
}

function numPages(state = 1, action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data.numPages;
    case `${FETCH_POST}${_ERROR}`:
    default:
      return state;
  }
}

function page(state = 1, action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data.page;
    case `${FETCH_POST}${_ERROR}`:
    default:
      return state;
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case `${FETCH_POST}${_REQUEST}`:
      return true;
    case `${FETCH_POST}${_ERROR}`:
    case `${FETCH_POST}${_SUCCESS}`:
      return false;
    default:
      return state;
  }
}

function basePath(state = '', action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data.basePath;
    default:
      return state;
  }
}

interface FullArticles {
  data: Article[];
  loading: boolean;
  numPages: number;
  page: number;
  basePath: string;
}

export type Articles = Partial<FullArticles>;

export default combineReducers<Articles>({
  data,
  loading,
  numPages,
  page,
  basePath
});
